import { YMaps, Map, Placemark, ZoomControl } from '@iminside/react-yandex-maps';
import styles from './Maps.module.scss';
import pin  from '../../shared/assets/photo/pin.png';

 
const API_KEY = "cb9799a4-2906-4959-9f2c-964b2e0a06cc"; 

const Maps = () => {
    const defaultState = {
        center: [45.091699, 39.006850],
        zoom: 14, 
        controls: []
      };
    return ( 
        <YMaps 
        query={{ 
            lang: 'RU',
            apikey: API_KEY,
            load: "package.full"
        }}
>
    <Map className={styles.mapImg} defaultState={defaultState}>
        <Placemark geometry={[45.091699, 39.006850]}
            modules={["geoObject.addon.balloon"]}
            properties={{                          
            balloonContentBody:
            "Стоматологическая клиника Итэр"
        }}
        options={{
            iconLayout: 'default#image',
            iconImageSize: [50, 50],
            iconImageHref: pin,
        }}
        />
        <ZoomControl options={{ float: "right" }} />
    </Map>
</YMaps>
    );
}

export default Maps;